import * as React from "react";
import { dropdownViewGet } from "../service/api-service";
import { Dropdown } from "primereact/dropdown";
import { FormControl, FormLabel } from "@mui/joy";
import { MultiSelect } from "primereact/multiselect";
import { InputSwitch } from "primereact/inputswitch";

interface inputPrams {
  label: string;
  apiPath: string;
  optionLabel: string;
  optionValue: string;
  selectedData?: (string | number)[];
  setSelectedData: any;
  setSelectedObject?: React.Dispatch<any>;
  queryParams?: any;
  required?: boolean;
  disabled?: boolean;
  showAll?: boolean;
}

export default function MultiDropdownApi(params: inputPrams) {
  const { label, apiPath, optionLabel, optionValue, selectedData, setSelectedData, queryParams, required, disabled, showAll, setSelectedObject } = params;
  const [allId, setAllId] = React.useState<string | number>();
  const [allChecked, setAllChecked] = React.useState(false);
  const [data, setData] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);

  const loadLazyData = () => {
    setLoading(true);
    dropdownViewGet(apiPath, queryParams)
      .then(data => {
        let records = data;
        if (showAll) {
          const allRecord = records.find(e => (e[optionLabel] as string).toLowerCase() == 'all');
          if (allRecord) {
            setAllId(allRecord[optionValue])
            const isChecked = selectedData?.includes(allRecord[optionValue] as string | number);
            setAllChecked(isChecked ?? false);
          };
        }

        records = records.filter(e => (e[optionLabel] as string).toLowerCase() != 'all');

        setData(records);
      })
      .catch(error => {
        console.log("error == ", error);
        setData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const setSelected = (event: any[]) => {
    setSelectedData(event);
    if (setSelectedObject) {
      const obj = data.filter(e => event.includes(e[optionValue]));
      setSelectedObject(obj);
    }
  };

  React.useEffect(() => {
    loadLazyData();
  }, [queryParams]);

  // Filter selected values to only include those that exist in current options
  const getValidSelectedValues = () => {
    if (!selectedData || !data.length) return selectedData || [];
    
    const validValues = selectedData.filter(value => 
      data.some(option => option[optionValue] === value)
    );
    
    return validValues;
  };

  return (
    <FormControl>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: '10px 0', width: 'fit-content' }}>
        <FormLabel style={{ margin: "auto" }}>
          {label}
          {required ? <div style={{ color: "red", display: "inline" }}>*</div> : ""}
        </FormLabel>
        {
          showAll && allId != undefined && (
            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginLeft: 10 }}>
              <FormLabel style={{ margin: "auto" }}>
                All
              </FormLabel>
              <InputSwitch checked={allChecked} onChange={(e) => {
                const isChecked = e.value;
                if (isChecked) {
                  setSelected([allId]);
                }
                setAllChecked(isChecked);
              }} />
            </div>
          )
        }
      </div>
      {data?.length > 0 ? (
        <MultiSelect
          className="PrimeSmallInput"
          style={{ fontSize: "small", padding: 0 }}
          onChange={(e: any) => {
            setSelected(e.value);
          }}
          value={(getValidSelectedValues() || [])[0] == allId ? [] : getValidSelectedValues()}
          options={data}
          panelClassName="custom-dropdown-panel"
          optionLabel={optionLabel}
          optionValue={optionValue}
          filter
          showClear
          filterBy={optionLabel}
          placeholder={`Select ${label}`}
          disabled={disabled || allChecked}
        />
      ) : (
        <MultiSelect
          className="PrimeSmallInput"
          style={{ fontSize: "small", padding: 0 }}
          placeholder={`Select ${label}`}
          loading
          disabled={disabled}
        />
      )}
    </FormControl>
  );
}
